import { render, staticRenderFns } from "./DownloadImageIcon.vue?vue&type=template&id=37159612"
import script from "./DownloadImageIcon.vue?vue&type=script&lang=js"
export * from "./DownloadImageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports